import { LOADING_STATUS } from '../../main/support/constants';
import type { ReducerWrapper } from '../types/ReduxAsyncActions.types';

export const INIT_WRAPPER_STATE: ReducerWrapper = {
  loading: false,
  error: null,
  loadingStatus: LOADING_STATUS.INIT,
};

export const PROGRESS_BAR_ACTIVE = 'PROGRESS_BAR_ACTIVE';

export const PROGRESS_BAR_COMPLETE = 'PROGRESS_BAR_COMPLETE';

export const PROGRESS_BAR_ERROR = 'PROGRESS_BAR_ERROR';

export const UNKNOWN_ERROR = 'Unknown error';

export const APP_CHANGE_ACTION_TYPE = 'APP_CHANGE';

const array = [];
export const EMPTY_ARRAY = Object.freeze(array) as typeof array;

const object = {};
export const EMPTY_OBJECT = Object.freeze(object) as typeof object;
